<div class="info-modal">
  <h1 mat-dialog-title>{{dataDialog.header}}</h1>
  <div mat-dialog-content class="body-content">
    {{dataDialog.message}}
  </div>
  <div mat-dialog-actions fxLayoutAlign="end center">
    <button mat-button (click)="onCloseModal()" cdkFocusInitial>Close</button>
  </div>
</div>